import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Erreur inattendue" };
  }

  componentDidCatch(error, info) {
    // Intentionnellement silencieux en production : l'état de repli est déjà géré
    // par getDerivedStateFromError. Aucun log console en production.
  }

  handleReset = () => {
    this.setState({ hasError: false, message: "" });
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-6 text-center" data-testid="error-boundary">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
            <AlertTriangle className="h-7 w-7 text-red-500" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Une erreur est survenue</h1>
            <p className="mt-1 max-w-md text-sm text-slate-500">
              L'application a rencontré un problème inattendu. Vous pouvez revenir à l'accueil et réessayer.
            </p>
          </div>
          <button
            onClick={this.handleReset}
            className="rounded-md bg-slate-900 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-slate-800"
            data-testid="error-reset-btn"
          >
            Retour à l'accueil
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
